<template>
    <div>
        <div ref="mychildcomponent" hidden id='viewStockInvoice' class="col-md-12">

            <!--HEADER-->
            <div class="col-md-12" style="height:45mm;border:2px solid #000000;" v-if="isHeaderFooter=='true'">
                <div class="row">
                    <div class="col-md-12">
                        <table class="table table-borderless">
                            <tr>
                                <td style="width:36%;" class="text-left pt-0 pb-0 pl-0 pr-0">
                                    <p class="mb-0">
                                        <span style="font-size:23px;color:black !important;font-weight:bold;">{{headerFooters.company.nameEnglish}}</span><br />
                                        <span style="font-size:15px;color:black !important;font-weight:bold;">{{headerFooters.company.categoryEnglish}}</span><br />
                                        <span style="font-size:14px;color:black !important;font-weight:bold;">VAT No.: {{headerFooters.company.vatRegistrationNo}}</span><br />
                                        <span style="font-size:14px;color:black !important;font-weight:bold;">Cr No.:{{headerFooters.company.companyRegNo}}</span><br />
                                        <span style="font-size:13px;color:black !important;font-weight:bold;">
                                            Tel: {{headerFooters.company.phoneNo}}
                                        </span>
                                    </p>
                                </td>
                                <td style="width:26%;" class="text-center pt-0 pb-0 pl-0 pr-0">
                                    <img :src="headerFooters.company.logoPath" style="width:auto;max-width:300px; max-height:100px; padding:5px !important; margin:0 !important">
                                </td>
                                <td style="width:38%;" class="pt-0 pb-0 pl-0 pr-0">
                                    <p class="text-right mb-0">
                                        <span style="font-size:23px;color:black !important;font-weight:bold;">{{headerFooters.company.nameArabic}}.</span><br />
                                        <span style="font-size:15px;color:black !important;font-weight:bold;">{{headerFooters.company.categoryArabic}}</span><br />
                                        <span style="font-size:14px;color:black !important;font-weight:bold;">رقم ضريبة القيمة المضافة: {{headerFooters.company.vatRegistrationNo}}</span><br />
                                        <span style="font-size:14px;color:black !important;font-weight:bold;">رقم السجل التجاري :{{headerFooters.company.companyRegNo}}</span><br />
                                        <span style="font-size:13px;color:black !important;font-weight:bold;">
                                            هاتف: {{headerFooters.company.phoneNo}}:
                                        </span>
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td style="width: 100%;font-size:15px;" class="text-center pt-0 pb-0 pl-0 pr-0" colspan="3">
                                    <span style="font-size:20px; padding-top:3px; font-weight:bolder" v-if="headerFooters.isStockIn">{{ $t('ViewStock.StockIn') }}</span>
                                    <span style="font-size:20px; padding-top:3px; font-weight:bolder" v-else>{{ $t('ViewStock.StockOut') }}</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div style="height:45mm;" v-else></div>

            <div style="height:30mm;margin-top:1mm; border:2px solid #000000;">
                <div class="row">
                    <div class="col-md-12 ml-2 mr-2">
                        <table class="table table-borderless">
                            <!--Row 1-->
                            <tr>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:14%; font-weight:bolder;text-align:right;color:black !important;font-size:14px !important;">Date:</td>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:25%; text-align:center;color:black !important;font-weight:bold;font-size:14px !important;">{{productDetail.date}}</td>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:11%;font-weight:bolder;font-size:14px !important;color:black !important;">:تاريخ</td>

                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:14%; font-weight:bolder;text-align:right;color:black !important;font-size:14px !important;">Stock Adj. No.:</td>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:25%; text-align:center;color:black !important;font-weight:bold;font-size:14px !important;">{{productDetail.code}}</td>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:11%;font-weight:bolder;font-size:14px !important;color:black !important;">:رقم تسوية المخزون</td>
                            </tr>

                            <!--Row 2-->
                            <tr v-if="headerFooters.isStockIn">
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:14%; font-weight:bolder;text-align:right;color:black !important;font-size:14px !important;">Warehouse Name:</td>
                                <td colspan="4" class="pl-0 pr-0 pt-0 pb-0" style="width:75%; text-align:center;color:black !important;font-weight:bold;font-size:14px !important;">{{productDetail.warehouseName}}</td>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:11%;font-weight:bolder;font-size:14px !important;color:black !important;">:اسم المستودع </td>
                            </tr>
                            <tr v-else>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:14%; font-weight:bolder;text-align:right;color:black !important;font-size:14px !important;">Warehouse Name:</td>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:25%; text-align:center;color:black !important;font-weight:bold;font-size:14px !important;">{{productDetail.warehouseName}}</td>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:11%;font-weight:bolder;font-size:14px !important;color:black !important;">:اسم المستودع</td>

                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:14%; font-weight:bolder;text-align:right;color:black !important;font-size:14px !important;">{{ $t('ViewStockInPrint.TaxMethod') }}:</td>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:25%; text-align:center;color:black !important;font-weight:bold;font-size:14px !important;">{{productDetail.taxMethod}}</td>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:11%;font-weight:bolder;font-size:14px !important;color:black !important;">:{{ $t('ViewStockInPrint.VAT%') }}</td>
                            </tr>

                            <!--Row 3-->
                            <tr>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:14%; font-weight:bolder;text-align:right;color:black !important;font-size:14px !important;">Remarks:</td>
                                <td colspan="4" class="pl-0 pr-0 pt-0 pb-0" style="width:75%; text-align:center;color:black !important;font-weight:bold;font-size:14px !important;">{{productDetail.narration}}</td>
                                <td class="pl-0 pr-0 pt-0 pb-0" style="width:11%;font-weight:bolder;font-size:14px !important;color:black !important;">:ملاحظات</td>
                            </tr>

                        </table>
                    </div>
                </div>
            </div>

            <!--INFORMATION-->
            <div style="border:2px solid !important; padding:5px;">
                <div class="row ">
                    <div class="col-lg-12 mt-2">
                        <table class="table table-borderless">
                            <thead style="background-color: #F4F6FC;">
                                <tr>
                                    <th style="width: 20px;">
                                        #
                                    </th>
                                    <th style="width: 150px;">
                                        {{ $t('ViewStockInPrint.ProductName') }}
                                    </th>
                                    <th style="width: 100px;" class="text-center">
                                        {{ $t('ViewStockInPrint.UnitPrice') }}
                                    </th>
                                    <th style="width: 70px;" class="text-center">
                                        {{ $t('ViewStockInPrint.salePrice') }}
                                    </th>
                                    <th style="width: 100px;" class="text-center">
                                        {{ $t('ViewStockInPrint.Quantity') }}
                                    </th>
                                    <!--<th style="width: 100px;" v-if="isFifo">
                                {{ $t('ViewStockItem.BatchNo') }}
                            </th>
                            <th style="width: 100px;" v-if="isFifo">
                                {{ $t('ViewStockItem.ExpDate') }}
                            </th>-->
                                    <th style="width: 110px;" class="text-center" v-if="isMultiUnit=='true'">
                                        {{ $t('ViewStockInPrint.TotalQty') }}
                                    </th>
                                    <th style="width: 100px;" class="text-right">
                                        {{ $t('ViewStockInPrint.Total') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody id="purchase-item">
                                <template v-for="(prod , index) in productDetail.stockAdjustmentDetails">

                                    <tr :key="prod.productId + index">
                                        <td class="border-top-0">
                                            {{index+1}}
                                        </td>
                                        <td class="border-top-0">
                                            <span v-if="($i18n.locale == 'en' ||isLeftToRight())">
                                                {{prod.product.englishName}}
                                            </span>
                                            <span v-else>
                                                {{prod.product.arabicName}}
                                            </span>
                                        </td>

                                        <td class="border-top-0 text-center">
                                            {{currency}} {{parseFloat(prod.price).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                        </td>
                                        <td class="border-top-0 text-center">
                                            {{currency}} {{parseFloat(prod.salePrice).toFixed(3).slice(0,-1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}
                                        </td>
                                        <td class="border-top-0 text-center" v-if="isMultiUnit=='true'">
                                            {{prod.highQty}} - {{prod.quantity}}
                                        </td>
                                        <td class="border-top-0 text-center" v-else>
                                            {{prod.quantity}}
                                        </td>

                                        <!--<td class="border-top-0 text-center" v-if="isFifo">
                                    <span> {{prod.batchNo}}</span>
                                </td>

                                <td class="border-top-0 text-center" v-if=" isFifo">
                                    <span>{{getDate(prod.batchExpiry)}}</span>

                                </td>-->
                                        <td class="border-top-0 text-center" v-if="isMultiUnit=='true'">
                                            {{prod.totalQty}}
                                        </td>
                                        <td class="border-top-0 text-right">
                                            {{currency}}  {{parseFloat(prod.total).toFixed(3).slice(0,-1) | formatAmount}}
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>


                        <table class="table table-borderless">
                            <thead class="m-0">
                                <tr class="arabicLanguage">
                                    <th class="text-center" style="width:30%">
                                        {{ $t('ViewStockInPrint.NoItem') }}
                                    </th>
                                    <th class="text-center" style="width:35%;">
                                        {{ $t('ViewStockInPrint.TotalQty') }}
                                    </th>
                                    <th class="text-center" style="width:35%;">
                                        {{ $t('ViewStockInPrint.Total') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="arabicLanguage">
                                    <td class="text-center">
                                        {{ summary.item }}
                                    </td>
                                    <td class="text-center">
                                        {{ summary.qty }}
                                    </td>
                                    <td class="text-center">
                                        {{currency}}   {{ summary.total}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import clickMixin from '@/Mixins/clickMixin'
    import { required } from "vuelidate/lib/validators";
    import moment from "moment";
    export default {
        mixins: [clickMixin],
        name: "ViewStockInPrint",
        props: ['printDetails', 'headerFooter'],
        data: function () {
            return {
                isMultiUnit: '',
                isFifo: false,
                stockAdjustmentDetails: [],
                render: 0,
                productDetail: {
                    id: '00000000-0000-0000-0000-000000000000',
                    date: '',
                    narration: '',
                    code: '',
                    warehouseId: '',
                    isDraft: true,
                    stockAdjustmentType: '',
                    stockAdjustmentDetails: [],
                    taxMethod: '',
                    taxRateId: "",
                    reason: '',
                },
                loading: false,
                language: 'Nothing',
                options: [],
                reasonOptions: [],
                summary: {
                    item: 0,
                    qty: 0,
                    total: 0,
                    vat: 0,
                },
                currency: '',
                headerFooters: {
                    company: '',
                    isStockIn: ''
                }

            }
        },
        validations: {
            productDetail: {
                date: {
                    required
                },
                code: {
                    required
                },
                warehouseId: {
                    required
                }
            }
        },
        methods: {
            getDate: function (x) {
                if (x == null) {
                    return '-'
                }
                else {
                    return moment(x).format("DD/MM/yyyy");
                }

            },
            calcuateSummary: function () {


                var isMultiUnit = localStorage.getItem('IsMultiUnit');
                if (isMultiUnit == 'true') {
                    this.productDetail.stockAdjustmentDetails.forEach(function (x) {

                        x.totalQty = x.quantity;
                        x.total = parseFloat(x.price) * x.quantity;
                        x.highQty = parseInt(parseInt(x.quantity) / parseInt(x.product.unitPerPack));
                        x.quantity = parseInt(parseInt(x.quantity) % parseInt(x.product.unitPerPack));

                    });
                    this.summary.item = this.productDetail.stockAdjustmentDetails.length;
                    this.summary.qty = this.productDetail.stockAdjustmentDetails.reduce(
                        (qty, prod) => qty + parseInt(parseInt(prod.quantity) + (parseInt(prod.highQty) * parseInt(prod.product.unitPerPack))), 0);
                    this.summary.total = this.productDetail.stockAdjustmentDetails
                        .reduce((total, prod) => total + parseFloat(prod.total), 0)
                        .toFixed(3).slice(0, -1);
                }
                else {
                    this.productDetail.stockAdjustmentDetails.forEach(function (x) {

                        x.total = parseFloat(x.price) * x.quantity;

                    });
                    this.summary.item = this.productDetail.stockAdjustmentDetails.length;
                    this.summary.qty = this.productDetail.stockAdjustmentDetails.reduce(
                        (qty, prod) => qty + parseInt(parseInt(prod.quantity)), 0);
                    this.summary.total = this.productDetail.stockAdjustmentDetails
                        .reduce((total, prod) => total + parseFloat(prod.price) * prod.quantity, 0)
                        .toFixed(3).slice(0, -1);
                }






            },
            PrintInvoice: function () {
                
                var form = new FormData();
                form.append('htmlString', this.$refs.mychildcomponent.innerHTML);
                var root = this;

                root.$https.post('/Report/PrintPdf', form, { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }, responseType: 'blob' })
                    .then(function (response) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        var date = moment().format('DD MMM YYYY');
                        link.setAttribute('download', 'ProductStock ' + date + '.pdf');
                        document.body.appendChild(link);
                        link.click();
                    });
                /*this.$htmlToPaper('viewStockInvoice');*/
            },
            languageChange: function (lan) {
                if (this.language == lan) {
                    if (this.productDetail.id == '00000000-0000-0000-0000-000000000000') {

                        var getLocale = this.$i18n.locale;
                        this.language = getLocale;

                        this.$router.go('/addSale');
                    }
                    else {
                        this.$swal({
                            title: 'Error!',
                            text: 'You cannot Change language during update, otherwise your current page data will be lose',
                            type: 'error',
                            confirmButtonClass: "btn btn-danger",
                            icon: 'error',
                            timer: 4000,
                            timerProgressBar: true,
                        });
                    }
                }


            },

            onCancel: function () {
                this.$router.push('/stockValue?formName=' + this.formName);
            },

        },
        created() {
            this.isFifo = localStorage.getItem('fIFO') == 'true' ? true : false;
            this.isHeaderFooter = localStorage.getItem('IsHeaderFooter');
            if (this.printDetails != undefined) {

                this.productDetail = this.printDetails;
                this.headerFooters = this.headerFooter;
                this.productDetail.date = moment(this.printDetails.date).format("DD/MM/YYYY");
                this.calcuateSummary();
            }
        },
        mounted: function () {
            this.isMultiUnit = localStorage.getItem('IsMultiUnit');
            var root = this;
            this.currency = localStorage.getItem('currency');
            this.language = this.$i18n.locale;
            setTimeout(function () {
                root.PrintInvoice();
            }, 125)





        }
    }
</script>
